import { FC, useMemo } from "react";
import dayjs, { Dayjs } from "dayjs";
// i18next
import { useTranslation } from "react-i18next";
// MUI
import { Box, Chip, Typography } from "@mui/material";

interface QuickRange {
  key: string;
  start: Dayjs;
  end: Dayjs;
  label: string;
}

type Props = {
  onChange: (start:Dayjs, end:Dayjs) => void;
}

const QuickDateChips:FC<Props> = ({ onChange }) => {
  const { t } = useTranslation();

  const quickDateRanges:QuickRange[] = useMemo(() => [
    {
      key: 'this-month',
      start: dayjs().startOf('month'),
      end: dayjs().endOf('month'),
      label: t('labels.thisMonth'),
    },
    {
      key: 'last-month',
      start: dayjs().subtract(1, 'month').startOf('month'),
      end: dayjs().subtract(1, 'month').endOf('month'),
      label: t('labels.lastMonth'),
    },
    {
      key: 'last-3-months',
      start: dayjs().subtract(2, 'month').startOf('month'),
      end: dayjs().endOf('month'),
      label: t('labels.last3Months'),
    },
    {
      key: 'this-year',
      start: dayjs().startOf('year'),
      end: dayjs().endOf('year'),
      label: t('labels.thisYear'),
    },
    {
      key: 'last-year',
      start: dayjs().subtract(1, 'year').startOf('year'),
      end: dayjs().subtract(1, 'year').endOf('year'),
      label: t('labels.lastYear'),
    },
  ], [t]);

  return (
    <Box>
      <Typography sx={{ fontWeight: 500, mt: 2, fontSize: 13, color: 'rgba(0,0,0,0.8)' }}>
        {t('labels.autoSelectRange')}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 2, flexWrap: 'wrap' }}>
        {quickDateRanges.map(({ key, label, start, end }) => (
          <Chip key={key} label={label} onClick={() => onChange(start, end)} />
        ))}
      </Box>
    </Box>
  )
};

export default QuickDateChips;
